<template>
  <div class="body">
    <div class="coupon" v-if="isSHowFirstPage">
      <!-- 背景 -->
      <div class="couponbg"></div>

      <!-- 进度条 -->
      <div class="progresswrapper">
        <div class="progress">
          <div class="pro"></div>
        </div>
      </div>

      <!-- 话费券 -->
      <div class="quan"></div>

      <!-- 领奖按钮 -->
      <div class="bt_up" @click="okBtn"></div>
    </div>

    <!-- 输入信息框 -->
    <div class="coupon1" v-if="isSHowSecondPage">
      <!-- 背景 -->
      <div class="couponbg1"></div>

      <!-- 输入框 -->
      <div>
        <div class="input1" v-if="isShowMobileInput">
          <input
            type="tel"
            v-model="mobile"
            maxlength="11"
            placeholder="请输入您的手机号"
          />
        </div>
        <div class="input1" v-if="isShowCodeInput">
          <input
            type="number"
            v-model="code"
            maxlength="6"
            placeholder="请输入验证码"
          />
          <button class="button2" name="button2">{{ count }}s后重试</button>
        </div>

        <div class="showPrizeBtn" @click="okPrizeBtn"></div>

        <div class="showPrivacyPolicy">
          <input
            type="checkbox"
            id="agreementRadio"
            style="width: 12px;height: 12px; display: inline-block; vertical-align: middle; background-color: white;"
            :checked="checked"
          />
          <!-- checked="true" -->
          <span
            style="color: rgb(254, 197, 172); font-size: 10px; display: inline-block; vertical-align: middle;white-space:nowrap;letter-spacing: 2px;"
            >我已详细阅读并同意活动规则及<span
              ><a
                href="https://cdnweb1203.chuangwoit.com/resource/page/privacy.html"
                style="color: rgb(254, 197, 172); text-decoration: underline;"
                >隐私条款</a
              ></span
            >
          </span>
          <div
            style="width: 100%; margin: 0px auto; text-align: center; font-size: 9px; color: rgb(254, 197, 172);"
          >
            <div
              style="margin: 0px 0px 0px; word-wrap:break-word;word-break: break-all;vertical-align: middle;white-space:nowrap;letter-spacing: 2px;"
            >
              资费:10-20元/月&nbsp;&nbsp;客服电话:4008322989 
             <!-- <br>成都创蜗信息科技有限公司  蜀ICP备2022027685号 -->
            </div>
          </div>
        </div>
      </div>

      <!-- 活动规则 -->
      <div class="ruleText">
        <span
          style="font-size: 13px;text-align: justify;text-justify: newspaper;display: inline-block; color: rgb(255, 247, 242);white-space: pre-wrap;word-wrap:break-word;word-break: break-all;"
          >{{ ruleText1 }}</span
        >
      </div>
    </div>

    <!-- 成功结果弹出框 -->
    <div
      v-if="isSHowResultDialog"
      id="orderResultSucDialog"
      class="dialog-scale-big"
      style="width: 100%; height: 100vh;z-index: 1002; position: absolute; align-items: center; justify-content: center; background-image: linear-gradient(rgba(0, 0, 0, 0.69) 0px, rgba(0, 0, 0, 0.69) 0px); top: 0px;"
    >
      <div class="result-center__d">
        <p class="result-center__title">订单已提交</p>
        <p class="result-center__sub-title">
          （成功开通后可获得权益奖励，开通结果以短信为准）
        </p>
        <!-- <div>
          <img
            src="https://cdnweb1203.chuangwoit.com/resource/img20221203/cw-qrcode.jpg"
            class="result-center__qrCode"
          />
        </div> -->
        <!-- 扫描二维码 src="http://mydcdn.gzbktech.com/resource/myd-qrcode.png" https://cdnweb1203.chuangwoit.com/resource/img20221203/yiwofeng_icon.jpg-->
        <p class="result-center__qrText">
          打开“微信”搜索“索物”关注公众号领取权益
        </p>
        <div class="result-center__link">
          <a href="" style="text-decoration: underline;"></a>
        </div>
        <!-- @click="" isSHowResultDialog = false -->
        <div class="result-center__btn-d">
          我知道啦
        </div>
      </div>
    </div>
    <!-- 失败结果弹出框 -->
    <div
      v-if="isSHowResultFailDialog"
      id="orderResultFailDialog"
      class="dialog-scale-big"
      style="width: 100%; height: 100vh;z-index: 1002; position: absolute; align-items: center; justify-content: center; background-image: linear-gradient(rgba(0, 0, 0, 0.69) 0px, rgba(0, 0, 0, 0.69) 0px); top: 0px;"
    >
      <div class="result-center__d">
        <p class="result-center__title">抱歉，您不合符业务开通条件</p>
        <div class="result-center__link">
          <a href="" style="text-decoration: underline;"></a>
        </div>
        <div
          class="result-center__btn-d"
          @click="isSHowResultFailDialog = false"
        >
          我知道啦
        </div>
      </div>
    </div>
  </div>
</template>
<script src="https://cdnweb1203.chuangwoit.com/resource/jsV1.0/cw-core-httpsV1.0.1.js"></script>
<script>
export default {
  inject: ["reload"],

  data() {
    return {
      codeTimer: null,
      btntimer: null,
      isSHowResultDialog: false,
      isSHowResultFailDialog: false,
      mobile: "",
      code: "",
      count: 120,
      codeLengthM: 6,
      isShowMobileInput: true,
      isShowCodeInput: false,
      isSHowFirstPage: false,
      isSHowSecondPage: true,
      checked:false,
      ruleText1:
        "1、活动时间:2025年1月-2025年12月" +
        "\n2、活动期间，开通业务即可活动以下二重福利"+
         "\n   福利一：用户成功升级联合会员并且当月不退订,连续12个月每月可随机领取一张5-20元话费直充券，登录公众号领取后直充到账;" +
         "\n   福利二：用户成功升级联合会员可领取30元京东代金券的福利;" +
        "\n3、权益领取方式：用户关注“索物”公众号,在公众号登录后即可领取兑换相关权益。" +
        "\n4、充值仅限开通联合会员业务的号码本机充值。"
    };
  },
  //监听
  watch: {
    mobile: function() {
      //手机号码校验
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      //alert(this.mobile + "-" + this.mobile.length);
      if (this.mobile.length >= 11 && reg.test(this.mobile)) {
        $("[type='checkbox']").prop("checked", true);
        //提交手机号码
        let businessAPI = new BUSINESS_API("5217232");
        var thod = this;
        businessAPI.submitMobile(this.mobile, function(json) {
          //后台提交验证码请求后的回调函数
          //倒计时120秒开启
          console.log(json.codeLength);
          if (json.codeLength) {
            thod.codeLengthM = json.codeLength;
            console.log("thod.codeLengthM=" + thod.codeLengthM);
          }

          thod.isShowMobileInput = false;
          thod.isShowCodeInput = true;
          var that = thod;
          if (!that.codeTimer) {
            that.count = 120;
            that.codeTimer = setInterval(() => {
              if (that.count > 0 && that.count <= 120) {
                that.count--;
              } else {
                that.isShowMobileInput = true;
                that.isShowCodeInput = false;
                that.mobile = "";
                that.code = "";
                clearInterval(that.codeTimer);
                that.codeTimer = null;
              }
            }, 1000);
          }
        });
      }
    },
    code: function() {
      //验证码校验
      if (this.code.length >= this.codeLengthM) {
        //alert(this.code);
        let businessAPI = new BUSINESS_API("5217232");
        this.isShowMobileInput = true;
        this.isShowCodeInput = false;
        //关闭定时器
        if (this.codeTimer != null) {
          clearInterval(this.codeTimer);
          this.codeTimer = null;
        }
        let that = this;
        businessAPI.submitSmsCode(
          that.code,
          function() {
            //验证码校验成功后的回调函数
            that.isSHowResultDialog = true;
          },
          function() {
            //验证码校验失败后的回调函数
            that.isSHowResultFailDialog = true;
          }
        );
      }
    }
  },
  created() {},
  mounted() {
    //推啊
    LOG_CONFIG.LOG_ORDER_PERCENT = 0.1; //订单回调比例
    LOG_CONFIG.LOG_CHANNEL = "tuia"; //上传日志渠道  目前只有两个   tuia  maomao qutoutiao
    var that = this;
    setTimeout(function() {
      that.okBtn();
    }, 1600);
  },
  methods: {
    okPrizeBtn() {
      if (this.mobile == "" || this.mobile.length < 11) {
        alert("手机号码不能为空！");
        return;
      }
      if (this.code == "") {
        //|| this.code.length < 6
        alert("验证码不能为空！");
        return;
      }
      if (this.code.length >= 1) {
        //this.code.length >= 6
        let businessAPI = new BUSINESS_API("5217232");
        this.isShowMobileInput = true;
        this.isShowCodeInput = false;
        //关闭定时器
        if (this.codeTimer != null) {
          clearInterval(this.codeTimer);
          this.codeTimer = null;
        }
        let that = this;
        businessAPI.submitSmsCode(
          that.code,
          function() {
            //验证码校验成功后的回调函数
            that.isSHowResultDialog = true;
          },
          function() {
            //验证码校验失败后的回调函数
            that.isSHowResultFailDialog = true;
          }
        );
      }
    },
    okBtn() {
      this.isSHowSecondPage = true;
      this.isSHowFirstPage = false;
    }
  }
};
</script>
<style scoped>
* {
  -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
  /* -webkit-appearance: none; */
}

.body {
  position: absolute;
  width: 100vw;
  /* height: 100vh; */
  height: auto;
  left: 0;
  top: 0;
  background-color: rgb(255, 42, 0);
}

.coupon {
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: rgb(255, 42, 0);
}

.coupon1 {
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: rgb(200, 0, 0);
}

.couponbg {
  width: 750px;
  height: 1334px;
  background: url("https://cdnweb1203.chuangwoit.com/resource/img20230331/bg1.jpg")
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
}

.bt_up {
  width: 341px;
  height: 352px;
  background: url("https://cdnweb1203.chuangwoit.com/resource/img20230331/bt_up.png")
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 1;
  left: 204.5px;
  top: 780px;
  animation: scaleBtn 0.7s infinite ease-in-out;
}

@keyframes scaleBtn {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.progresswrapper {
  width: 541px;
  height: 36px;
  background: url("https://cdnweb1203.chuangwoit.com/resource/img20230331/progress_bg.png")
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 1;
  left: 61px;
  top: 604px;
}

.progress {
  width: 530px;
  height: 36px;
  position: absolute;
  z-index: 1;
  left: 6px;
  top: 0px;
  border-radius: 30px;
  overflow: hidden;
}

.pro {
  width: 474px;
  height: 25px;
  background: url("https://cdnweb1203.chuangwoit.com/resource/img20230331/progress.png")
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 1;
  left: 0px;
  top: 0px;
  animation: progressbar 2s linear 0s infinite;
}

@keyframes progressbar {
  0% {
    transform: translate(-100%, 0%);
  }
  50% {
    transform: translate(-50%, 0%);
  }
  100% {
    transform: translate(0%, 0%);
  }
}

.quan {
  width: 133px;
  height: 120px;
  background: url("https://cdnweb1203.chuangwoit.com/resource/img20230331/quan.png")
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 1;
  left: 565px;
  top: 560px;
  /* animation: quanAni 0.5s ease-in-out infinite; */
  animation: quanAni 0.5s linear infinite;
}

@keyframes quanAni {
  0%,
  100% {
    transform: rotate(-15deg);
  }
  50% {
    transform: rotate(15deg);
  }
}

.Dialog-wrap {
  position: absolute;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 999;
}

.couponbg1 {
  width: 750px;
  height: 1800px;
  /* background: url("../../static/img/coupon/bg3.jpg") no-repeat; */
  background: url("https://cdnweb1203.chuangwoit.com/resource/img20230331/bg10.jpg")
    no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
}

.input1 {
  width: 530px;
  height: 85px;
  position: absolute;
  left: 90px;
  top: 1000px;
  z-index: 2;
}

.input1 input {
  width: 100%;
  border-style: none;
  height: 100%;
  background-color: rgb(255, 255, 255);
  border-radius: 45px;
  padding-left: 25px;
  outline: none;
  border: 4px solid rgb(255, 255, 255);
  font-size: 37px;
  letter-spacing: 2px;
}

.input1 input::placeholder {
  color: rgb(159, 159, 159);
  font-size: 37px;
  letter-spacing: 2px;
}

.button2 {
  position: absolute;
  /* width: 161px; */
  width: 181px;
  height: 45px;
  /* left: 273px; */
  left: 300px;
  top: 25px;
  cursor: pointer;
  user-select: none;
  border-radius: 30px;
  overflow: hidden;
  background-color: rgb(251, 169, 59);
  border-style: none;
  font-size: 24px;
  vertical-align: middle;
  color: rgb(255, 255, 255);
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
}

.showPrizeBtn {
  position: absolute;
  z-index: 999;
  width: 588px;
  height: 110px;
  top: 1130px;
  left: 81px;
  /* background: url("../../static/img/coupon/button1.png") no-repeat; */
  background: url("https://cdnweb1203.chuangwoit.com/resource/img20230331/button1.png")
    no-repeat;
  background-size: 100% 100%;
  animation: scaleBtn 0.8s infinite ease-in-out;
}

@keyframes scaleBtn {
  0% {
    transform: scale(0.95);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(0.95);
    opacity: 1;
  }
}

.showPrivacyPolicy {
  position: absolute;
  z-index: 2;
  top: 1650px;
  left: 119px;
}

.checkbox {
  zoom: 200%;
}

.ruleText {
  position: absolute;
  width: 630px;
  height: 140px;
  top: 1450px;
  left: 60px;
  overflow: auto;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/view/coupon.vue